<!-- Logica de debate y notas, esta parte solo muestra el comentario principal (commentForm, addPost, posts, paginación). -->
<div class="timeline">

	<p class="hidden text-sm text-gray-500 leading-relaxed">
		{{ 'player.timeline.discussion.description' | translate }}
	</p>

	<h4 class="text-sm font-bold text-[#22304C] mb-2" [ngClass]="context === 'exchange' ? 'mt-4' : 'mt-0'">{{'player.timeline.discussion.subtitle' | translate}}</h4>
	<!-- Tarjeta informativa decorativa. -->
	<div class="mt-4 flex items-start gap-3 p-3 rounded-xl border border-[#E8EAEF]">
		<div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style="background: var(--primary-color);">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 text-white">
				<path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path>
				<path d="M9 18h6"></path>
				<path d="M10 22h4"></path>
			</svg>
		</div>
		<p class="text-sm text-gray-500 leading-relaxed">
			{{ 'player.timeline.discussion.info' | translate }}
		</p>
	</div>

	<div class="mt-2">
		<!-- Caja rosa con el formulario de nuevo post (timeline-add-content conserva su lógica). -->
		<form #commentForm class="new-post  p-3" >
			<timeline-add-content (addContent)="addPost($event)" [placeholder]="'player.timeline.placeholder.ask' | translate" [avatar]="me?.picture" [avatarInitial]="me?.name?.charAt(0)"></timeline-add-content>
		</form>
	</div>


	<div class="mt-2">
		<h4 *ngIf="items?.length > 0" class="text-sm font-bold text-[#22304C] mb-2">
			{{'question.correction.title' | translate}} <span class="px-1 text-gray-400 text-xs font-normal">{{ items?.length }}</span>
		</h4>
	</div>


	<div *ngIf="timelineId && ready" class="mt-4">
		<div class="my-4" *ngFor="let item of items">
			<msc-post (updateExchange)="sendEmitterToExchange()" [context]="context" [contextId]="contextId" [isTrajectContent]="course.isTrajectContent" [post]="item" [timelineId]="timelineId" (onDelete)="deletePost($event)"></msc-post>
		</div>

		<div class="mx-4 px-2 load-more grey flex justify-center" *ngIf="pagination?.lastPage > pagination?.currentPage">
			<button class="btn light-grey load-more__button btn_round btn_height_small load-more__button--outline" (click)="nextPosts()">
				<span>{{ 'player.load-more' | translate }}</span>
			</button>
			<div class="dot"></div>
		</div>
	</div>
</div>

<style>
    /* Botón "Cargar más": borde gris y texto gris por defecto, bg-primary al hover.
       Selector "button.load-more__button--outline" (elemento + clase) para tener más
       especificidad que la regla global "button.btn" que fuerza background secondary. */
    button.load-more__button--outline {
        background: #fff !important;
        border: 1px solid #E5E7EB !important;
        color: #6B7280 !important;
    }

    button.load-more__button--outline:hover {
        background: var(--primary-500) !important;
        border-color: var(--primary-500) !important;
        color: #fff !important;
    }

    button.load-more__button--outline:focus {
        background: #fff !important;
        border-color: #E5E7EB !important;
        color: #6B7280 !important;
        outline: none !important;
        box-shadow: none !important;
    }
</style>
